import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Select from "react-select";
import TransplantsFacilitatedTable from "./TransplantsFacilitatedTable";
import { brandColorArray } from "../../../utilities/formatter";
import NoData from "../../../utilities/NoData";

import "highcharts/modules/exporting";
import "highcharts/modules/export-data";
import "highcharts/modules/accessibility";

function TransplantsFacilitatedChart(props) {
    let title = props.title;
    let subTitle = props.organ ? `Characteristics of deceased donor ${props.organ} recipients` : "";
    const uniqueId = `transplantsFacilitated-${Math.random()}`;
    const chartRef = useRef(null);
    const yearOneLabel = props.data ? `${props.data.yearOne}` : "";
    const yearTwoLabel = props.data ? `${props.data.yearTwo}` : "";
    const [chartOptions, setChartOptions] = useState({
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ['printChart', 'downloadPNG', 'downloadSVG', 'downloadPDF', 'downloadCSV']
                },
            },
            title: {
                text: `<div style="font-family:Open Sans;font-size:14px;font-weight: 700;text-align:center;">${title}</div><br /><div style="font-family:Open Sans;font-size:12px;font-weight: 400;text-align:center;">${subTitle}</div>`
            },
            chart: {
                events: {
                    load: function () {
                        let width = 0;
                        let height = this.chartHeight - 50;
                        this.renderer.image('/srtr_logo.jpg', width, height, 50, 50)
                            .add();
                    }
                }
            }
        },
        chart: {
            type: "column"
        },

        credits: {
            enabled: false
        },
        title: {
            text: ""
        },
        xAxis: {
            categories: [
                `${props.opoCode.toUpperCase()} <br />${yearOneLabel}`,
                `US <br />${yearOneLabel}`,
                `${props.opoCode.toUpperCase()} <br />${yearTwoLabel}`,
                `US <br />${yearTwoLabel}`,
            ],
            labels: {
                style: {
                    fontFamily: "Open Sans",
                    fontSize: "14px"
                }
            }
        },
        yAxis: {
            title: {
                style: {
                    fontFamily: "Open Sans",
                    fontSize: "14px"
                }
            },
            labels: {
                style: {
                    fontFamily: "Open Sans",
                    fontSize: "14px"
                }
            },
            max: 100,
            reversedStacks: false
        },
        tooltip: {
            borderWidth: 0,
            backgroundColor: '#FCFFC5',
            borderRadius: 10,
            shadow: true,
            useHTML: true,
            headerFormat: '<div style="font-family:Open Sans;font-size:14px;font-weight: 700;text-align:center;margin-bottom:10px">{point.key}</div>',
            pointFormat: '<div style="padding:0px 5px 5px 5px;font-family:Open Sans;font-size:14px;font-weight: 700;text-align:left"><span>{series.name}</span>: <span style="font-family:Open Sans;font-size:14px;font-weight: 600;text-align:left">{point.y:.1f}</span></div>',
            shared: false
        },

        legend: {
            itemStyle: {
                fontFamily: "Open Sans",
                fontSize: "14px"

            }
        },
        labels: {
            useHTML: true,
            allowOverlap: true,
            style: {
                wordBreak: 'break-all',
                textOverflow: 'allow'
            }
        },
        plotOptions: {
            column: {
                stacking: 'column'
            }
        }
    });


    const _onChange = (_selectedOption) => {

        if (chartRef && chartRef.current && chartRef.current.chart && _selectedOption) {
            let chart = chartRef.current.chart;
            let _selectedValue = _selectedOption.value;
            let series = _selectedValue.map((x, index) => {
                let newSeries = {
                    name: x.label,
                    color: brandColorArray[index],
                    data: [props.data[x.value.opoYearOne], props.data[x.value.usYearOne], props.data[x.value.opoYearTwo], props.data[x.value.usYearTwo]]
                };

                return newSeries;
            });

            let _newOptions = {
                ...chartOptions,
                series: series
            }

            chart.yAxis[0].update({
                title: { text: _selectedOption.label }
            });

            setChartOptions(_newOptions)
        }
    };

    useEffect(() => {
        _onChange(props.selectOptions[0]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (props.data) {
        return (
            <div className="transplants-facilitated-chart">
                <Row>
                    <Col xs={12} className="text-center">
                        <div className="sub-title mt-4">
                            {subTitle}
                        </div>
                    </Col>
                </Row>
                <Row >
                    <Col xs={12} lg={8}>
                        <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ className: "highcharts-light" }}/>
                    </Col>
                    <Col xs={12} lg={4}>
                        <div className="green-control-box">
                            <div className="description" id={`label-${uniqueId}`} htmlFor={uniqueId}>
                                Select characteristic
                            </div>
                            <Select
                                id={uniqueId}
                                className="select-characteristics"
                                classNamePrefix="select"
                                isClearable={false}
                                isSearchable={true}
                                name="characteristics"
                                options={props.selectOptions}
                                onChange={_onChange}
                                defaultValue={props.selectOptions[0]}
                                aria-labelledby={`label-${uniqueId}`}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} >
                        {props.data &&
                            <TransplantsFacilitatedTable
                                opoCode={props.opoCode}
                                data={props.data}
                                organ={props.organ}
                                options={props.selectOptions}
                                yearOne={yearOneLabel}
                                yearTwo={yearTwoLabel}
                                prefix={props.prefix}
                            />
                        }
                    </Col>
                </Row>
            </div>
        );
    }
    else {
        return (
            <div className="transplants-facilitated-chart">
                <Row>
                    <Col xs={12} className="text-center">
                        <div className="sub-title mt-4">
                            Characteristics of deceased donor {props.organ} recipients
                        </div>
                    </Col>
                </Row>
                <NoData />
            </div>
        );
    }
}

export default TransplantsFacilitatedChart;